import { createStore } from 'vuex'

export default createStore({
    state: {
        players: [],
        playersRoom: [],  // spelers aan tafel, in volgorde
        settings: {
            cardDeck: 52,
        },
    },
    mutations: {
        addPlayer(state, player) {
            state.players.push(player)
        },
        removePlayer(state, id) {
            state.players = state.players.filter(p => p.id !== id)
            state.playersRoom = state.playersRoom.filter(p => p.id !== id)
        },
        setPlayersRoom(state, players) {
            state.playersRoom = players
        },
        addToRoom(state, player) {
            if (!state.playersRoom.find(p => p.id === player.id)) {
                state.playersRoom.push(player)
            }
        },
        removeFromRoom(state, id) {
            state.playersRoom = state.playersRoom.filter(p => p.id !== id)
        },
        setCardDeck(state, size) {
            state.settings.cardDeck = size
        },
    },
})